/**
 * @file useUncontrolledShow
 */
import { useUncontrolled } from './useUncontrolled';
export function useUncontrolledShow(options) {
  var show = options.show,
      defaultShow = options.defaultShow,
      onHide = options.onHide,
      onShow = options.onShow,
      onVisibleChange = options.onVisibleChange;
  return useUncontrolled(typeof show === 'boolean', false, show, defaultShow, function (nv) {
    if (nv) {
      onShow && onShow();
    } else {
      onHide && onHide();
    }

    onVisibleChange && onVisibleChange(nv);
  }, 'show');
}